<template>
  <div>
    <page-header title="ساخت پست جدید"></page-header>

    <crud-generator :fields="fields" @submit="submit" name="posts"></crud-generator>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import CrudGenerator from "@/components/General/CrudGenerator";

export default {
  name: "CreatePost",

  components: {CrudGenerator, PageHeader},

  data() {
    return {
      fields: [],
    }
  },

  mounted() {
    this.fillFields()
  },

  methods: {
    fillFields() {
      this.fields = [
        {
          name: 'fa_title',
          label: 'عنوان',
          cols: 4,
          type: 'text',
          direction: 'rtl',
        },
        {
          name: 'fa_short_description',
          label: 'توضیح کوتاه',
          cols: 8,
          type: 'text',
          direction: 'rtl'
        },
        {
          name: 'fa_content',
          label: 'متن',
          cols: 12,
          type: 'ckeditor',
          direction: 'rtl'
        },
        {
          name: 'fa_meta_title',
          label: 'عنوان متا',
          cols: 6,
          type: 'text',
          direction: 'rtl'
        },
        {
          name: 'fa_meta_keywords',
          label: 'کلیدواژه های متا',
          cols: 6,
          type: 'text',
          direction: 'rtl'
        },
        {
          name: 'fa_meta_descriptions',
          label: 'توضیحات متا',
          cols: 12,
          type: 'text',
          direction: 'rtl'
        },

        {
          name: 'en_title',
          label: 'Title',
          cols: 4,
          type: 'text',
          direction: 'ltr',
        },
        {
          name: 'en_short_description',
          label: 'Short Description',
          cols: 8,
          type: 'text',
          direction: 'ltr'
        },
        {
          name: 'en_content',
          label: 'Content',
          cols: 12,
          type: 'text',
          direction: 'ltr'
        },
        {
          name: 'en_meta_title',
          label: 'Meta Title',
          cols: 6,
          type: 'text',
          direction: 'ltr'
        },
        {
          name: 'en_meta_keywords',
          label: 'Meta Keywords',
          cols: 6,
          type: 'text',
          direction: 'ltr'
        },
        {
          name: 'en_meta_descriptions',
          label: 'Meta Description',
          cols: 12,
          type: 'text',
          direction: 'ltr'
        },

        {
          name: 'image',
          label: 'تصویر',
          cols: 4,
          type: 'image',
        },
      ]
    },

    submit(values) {
      this.$store.dispatch("createPost", values)
          .then(() => {
            this.$router.push('/posts')
          })
    },
  }
}
</script>

<style scoped>

</style>